









import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

/** import all UUIF components and services to verify the compilation */
import { ApiService } from '@libs-uuif/shared/api-service';
import { confirmService } from '@libs-uuif/shared/confirm-service';
import { domService } from '@libs-uuif/shared/dom-service';
import { drag } from '@libs-uuif/shared/drag-dir';
import { dropdown } from '@libs-uuif/shared/dropdown-dir';
import { i18nService } from '@libs-uuif/shared/i18n-service';
import { messageService } from '@libs-uuif/shared/message-service';
import { popover } from '@libs-uuif/shared/popover-dir';
import { popperService } from '@libs-uuif/shared/popper-service';
import { SwActionBar } from '@libs-uuif/shared/sw-action-bar';
import { SwApp } from '@libs-uuif/shared/sw-app';
import { SwAppIcon } from '@libs-uuif/shared/sw-app-icon';
import { SwAvatar } from '@libs-uuif/shared/sw-avatar';
import { SwBadge } from '@libs-uuif/shared/sw-badge';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import { SwBreadcrumb } from '@libs-uuif/shared/sw-breadcrumb';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwCardView } from '@libs-uuif/shared/sw-card-view';
import { SwChartBar } from '@libs-uuif/shared/sw-chart';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwChip } from '@libs-uuif/shared/sw-chip';
import { SwCircleMenu } from '@libs-uuif/shared/sw-circle-menu';
import { SwCircularButton } from '@libs-uuif/shared/sw-circular-button';
import { SwCountBlock } from '@libs-uuif/shared/sw-count-block';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwDashSwitch } from '@libs-uuif/shared/sw-dash-switch';
import { SwDatetimePicker } from '@libs-uuif/shared/sw-datetime-picker';
import { SwDropMenu } from '@libs-uuif/shared/sw-drop-menu';
import { SwFileUpload } from '@libs-uuif/shared/sw-file-upload';
import { SwForm } from '@libs-uuif/shared/sw-form';
import { SwGraphs } from '@libs-uuif/shared/sw-graphs';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwIconTab, SwIconTabDivider } from '@libs-uuif/shared/sw-icon-tab';
import { SwMap } from '@libs-uuif/shared/sw-map';
import { SwModal } from '@libs-uuif/shared/sw-modal';
import { SwNav } from '@libs-uuif/shared/sw-nav';
import { SwPanel } from '@libs-uuif/shared/sw-panel';
import { SwBarProgress } from '@libs-uuif/shared/sw-progress';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import { SwSlider } from '@libs-uuif/shared/sw-slider';
import { SwStatusFlag } from '@libs-uuif/shared/sw-status-flag';
import { SwStatusInfo } from '@libs-uuif/shared/sw-status-info';
import { SwSteps } from '@libs-uuif/shared/sw-steps';
import { SwTabGroup } from '@libs-uuif/shared/sw-tab-layout';
import { SwTable } from '@libs-uuif/shared/sw-table';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwTitlePane } from '@libs-uuif/shared/sw-title-pane';
import { SwToggle } from '@libs-uuif/shared/sw-toggle';
import { SwTransitionExpand } from '@libs-uuif/shared/sw-transition';
import { SwTreeDropdownSelect } from '@libs-uuif/shared/sw-tree-dropdown-select';
import { SwTreeList } from '@libs-uuif/shared/sw-tree-list';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { utilService } from '@libs-uuif/shared/util-service';

const cssPrefix = 'sw-ftr-hello-sonicwall';

@Component({
  components: {
    SwActionBar,
    SwApp,
    SwAppIcon,
    SwAvatar,
    SwBadge,
    SwBlockingProgress,
    SwBreadcrumb,
    SwButton,
    SwCardView,
    SwChartBar,
    SwCheckbox,
    SwChip,
    SwCircleMenu,
    SwCircularButton,
    SwCountBlock,
    SwCountryIcon,
    SwDashSwitch,
    SwDatetimePicker,
    SwDropMenu,
    SwFileUpload,
    SwForm,
    SwGraphs,
    SwIcon,
    SwIconButton,
    SwIconTab,
    SwIconTabDivider,
    SwMap,
    SwModal,
    SwNav,
    SwPanel,
    SwBarProgress,
    SwRadio,
    SwScrollView,
    SwSelect,
    SwSlider,
    SwStatusFlag,
    SwStatusInfo,
    SwSteps,
    SwTabGroup,
    SwTable,
    SwTextfield,
    SwTitlePane,
    SwToggle,
    SwTransitionExpand,
    SwTreeDropdownSelect,
    SwTreeList,
  },
})
export default class SwFtrHelloSonicwall extends SwExtendedVue {
  cssPrefix = cssPrefix;

  translated: boolean = false;

  @Watch('translated')
  onTranslatedChange() {
    if (this.translated) {
      i18nService.changeLang('zh-CN');
    } else {
      i18nService.changeLang('en-US');
    }
  }

  private dummyReference() {
    ApiService.prototype;
    confirmService.confirm;
    domService.resizeObserver;
    drag.bind;
    dropdown.bind;
    i18nService.changeLang;
    messageService.messageManager;
    popover.bind;
    popperService.generateDirective;
    tooltip.bind;
    utilService.numberWithCommas;
  }
}
